import { PaymentStatus } from 'constants/payment';
import { useIsMobile } from 'hooks';
import { useAppSelector } from 'store/hooks';

import { SwitchLocale } from '../../switch-locale';
import { DemoLabel } from '../demo-label';

const Header = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const { isMobile } = useIsMobile();

  return isMobile && paymentData?.status === PaymentStatus.WAIT_PAYMENT ? (
    <header className="p-4 gap-16 bg-white text-black flex items-start justify-between w-full">
      <div className="items-center gap-6 justify-center text-center">
        {paymentData?.isDemo && <DemoLabel />}
      </div>
      <div>
        <SwitchLocale />
      </div>
    </header>
  ) : (
    <header className="hidden gap-16 text-white md:flex items-start md:flex-row w-full">
      <div className="w-[140px]" />
      <div className="flex-grow items-center gap-6 justify-center text-center">
        {paymentData?.isDemo && <DemoLabel />}
      </div>
      <div className="w-[140px]">
        <SwitchLocale />
      </div>
    </header>
  );
};

export { Header };
